import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { RouteError } from "@/components/route-error";
import { NotFound } from "@/components/not-found";

const router = createRouter({
  routeTree,
  // Was src/app/error.tsx / not-found.tsx. Routes that need a bespoke one
  // (analytics, campaigns) override `errorComponent` themselves.
  defaultErrorComponent: RouteError,
  defaultNotFoundComponent: NotFound,
  // Every page's data comes from Convex `useQuery`, which has its own loading
  // states — a route only "loads" while its code-split chunk downloads, so
  // keep the pending skeletons from flashing on a fast connection.
  defaultPendingMs: 300,
  defaultPendingMinMs: 400,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error('index.html is missing <div id="root">');

createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
